// extracted by mini-css-extract-plugin
module.exports = {"linkStyle":"LinkFieldStyles_linkStyle__9DREb","copyIconStyle":"LinkFieldStyles_copyIconStyle__3qD6Z"};